import React from 'react'
import { Flex } from 'mds-web-ui'

export const FlexGrow = () => <Flex css={{ flexGrow: 1 }} />
